import { EventAction } from '../EventAction';
import { catchAction } from '../EventReceiver';
import { getService } from 'data/function';
export class SidebarProcessor {
    static get SidebarService() {
        return getService('SidebarService');
    }
    static process({ message }) {
        switch (catchAction(message.action)) {
            case EventAction.CloseSidebar:
                this.SidebarService.closeSidebar();
                break;
        }
    }
}
